import PropTypes from 'prop-types';
import _ from 'lodash';
import { useLocation } from 'react-router-dom';
import {
  AppBar as MuiAppBar,
  Box,
  Container,
  Toolbar,
  Typography,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { useEffect } from 'react';
import RouterOutlet from '../../pages/_router';
import AppBar from '../app-bar/container';
import AppMaintenance from '../app-maintenance/container';
import AutomaticLogout from '../automatic-logout/container';
import ContactIDRouteAction from '../contact-id-route-action/container';
import EnforceMfa from '../enforce-mfa/component';
import Loading from '../loading/component';
import styles from './styles';

function AppSecure({
  classes,
  session,
  contactidroute,
  portalAlert,
  getPortalAlert,
}) {
  const Mfa =
    import.meta.env.VITE_APP_ENABLE_ADVISER_MFA === 'true' ? EnforceMfa : 'div';

  const { pathname } = useLocation();

  useEffect(() => {
    getPortalAlert();
  }, [getPortalAlert]);

  if (!session || _.isEmpty(session)) {
    return <Loading />;
  }

  return (
    <Mfa>
      <Box className={classes.appContainer}>
        {portalAlert && portalAlert.Mode === 'online' && (
          <MuiAppBar position="static">
            <Toolbar color>
              <Container maxWidth="lg">
                <Typography align="center" variant="h2">
                  {portalAlert.Message}
                </Typography>
              </Container>
            </Toolbar>
          </MuiAppBar>
        )}

        {import.meta.env.VITE_APP_ENV === 'uat' && (
          <MuiAppBar position="static">
            <Toolbar color>
              <Container maxWidth="lg">
                <Typography align="center" variant="h2">
                  UAT
                </Typography>
              </Container>
            </Toolbar>
          </MuiAppBar>
        )}

        <AutomaticLogout />

        {!pathname.startsWith('/2fa-enrolment') && <AppBar />}

        <RouterOutlet />

        <AppMaintenance />
        {contactidroute?.length > 0 && <ContactIDRouteAction />}
      </Box>
    </Mfa>
  );
}

AppSecure.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
  session: PropTypes.object,
  contactidroute: PropTypes.string,
  portalAlert: PropTypes.object,
  getPortalAlert: PropTypes.func.isRequired,
};

AppSecure.defaultProps = {
  classes: {},
  session: {},
  contactidroute: null,
  portalAlert: null,
};

export default withStyles(styles)(AppSecure);
